import {FC, useEffect, useRef, useState} from "react";
import Icon from '../Icon/Icon.tsx';
import { IconTypes } from '../Icon/Icon-Constants.ts';
import "./FortuneCookie.scss";

interface FortuneCookieProps {
  fortune: string;
  getNewFortune: () => void;
}

const FortuneCookie: FC<FortuneCookieProps> = ({fortune, getNewFortune}) => {
  const [showFortune, setShowFortune] = useState(false);
  const fortuneCookieRef = useRef<HTMLElement>(null);

  const handleFortuneClick = () => {
    setShowFortune(!showFortune);
  }

  useEffect(() => {
    if (showFortune && fortuneCookieRef.current) {
      fortuneCookieRef.current.classList.remove('fortune-cookie--hide-message');
      fortuneCookieRef.current.classList.add('fortune-cookie--show-message');
      getNewFortune()
    } else if (!showFortune && fortuneCookieRef.current) {
      fortuneCookieRef.current.classList.remove('fortune-cookie--show-message');
      fortuneCookieRef.current.classList.add('fortune-cookie--hide-message');
    }
  }, [showFortune]); 

  return (
    <div className="fortune-cookie" ref={fortuneCookieRef as React.RefObject<HTMLDivElement>} onClick={handleFortuneClick}>
      <blockquote className="fortune-cookie__message header-sm" >
        {fortune}
      </blockquote>
      <div className="fortune-cookie__animation">
        <div className="fortune-cookie__icon"></div>
        <div className="fortune-cookie__shadow"></div>
      </div>
      <div className="fortune-cookie__refresh">
        <Icon name={IconTypes.refresh} />
      </div>
    </div>
  )
}

export default FortuneCookie;
